/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface CreatePaymentMethodCountryConnectionRequest
 */
export interface CreatePaymentMethodCountryConnectionRequest {
    /**
     * 
     * @type {CountryCode}
     * @memberof CreatePaymentMethodCountryConnectionRequest
     */
    countryCode: CountryCode;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePaymentMethodCountryConnectionRequest
     */
    paymentsEnabled: boolean;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof CreatePaymentMethodCountryConnectionRequest
     */
    defaultEnabledInApps: Set<FavritApp>;
}



/**
 * Check if a given object implements the CreatePaymentMethodCountryConnectionRequest interface.
 */
export function instanceOfCreatePaymentMethodCountryConnectionRequest(value: object): value is CreatePaymentMethodCountryConnectionRequest {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('paymentsEnabled' in value) || value['paymentsEnabled'] === undefined) return false;
    if (!('defaultEnabledInApps' in value) || value['defaultEnabledInApps'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodCountryConnectionRequestFromJSON(json: any): CreatePaymentMethodCountryConnectionRequest {
    return CreatePaymentMethodCountryConnectionRequestFromJSONTyped(json, false);
}

export function CreatePaymentMethodCountryConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodCountryConnectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': CountryCodeFromJSON(json['countryCode']),
        'paymentsEnabled': json['paymentsEnabled'],
        'defaultEnabledInApps': (new Set((json['defaultEnabledInApps'] as Array<any>).map(FavritAppFromJSON))),
    };
}

export function CreatePaymentMethodCountryConnectionRequestToJSON(json: any): CreatePaymentMethodCountryConnectionRequest {
    return CreatePaymentMethodCountryConnectionRequestToJSONTyped(json, false);
}

export function CreatePaymentMethodCountryConnectionRequestToJSONTyped(value?: CreatePaymentMethodCountryConnectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'paymentsEnabled': value['paymentsEnabled'],
        'defaultEnabledInApps': (Array.from(value['defaultEnabledInApps'] as Set<any>).map(FavritAppToJSON)),
    };
}

